// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import hopt from 'hola_opt';
// @ts-ignore
import cookie from 'cookie';
import {use_qs_with_set} from '../lib/use_qs';

export const use_campaign = ()=>{
    const {browser = [], vpn = []} = hopt.www_hola.campaigns||{};
    const {qs} = use_qs_with_set();
    const c_browser = cookie.get('c_browser');
    let c_vpn_c = cookie.get('c_vpn') && cookie.get('c_vpn')!=='organic' ?
        cookie.get('c_vpn') : '';
    const c_vpn = c_vpn_c || qs.campaign || qs.cam;
    return browser.find(({name})=>name==c_browser) ||
        vpn.find(({name})=>name==c_vpn) ;
};
